import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearch } from "../../../actions/DanhSachTatToanChoDuyet";

export const SearchBar = ({ SearchDanhSach }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchTatToanChoDuyet);

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
        pageIndex: 1,
      })
    );
  };

  const updateDropdown = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const onSearch = () => {
    SearchDanhSach();
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: 1,
        })
      );
      SearchDanhSach();
    }
  }; //sự kiện tìm kiếm enter
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Tìm kiếm</label>
          <input
            type="text"
            className="form-control input-sm "
            placeholder="Mã HĐ,Tên, SĐT, CMT khách hàng"
            //value={dataSearch.customerName}
            onChange={updateTextValue("customerName")}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div
          className="input-sm-new input-new-18 search-main-new"
          style={{ marginTop: "28px" }}
        >
          <button type="submit" className="btn btn-info-new" onClick={onSearch}>
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
